import { atom } from "recoil"

export const deviceTokenState = atom<string | null>({
  key: "atoms/account/deviceTokenState",
  default: null,
})
